@import "general/scss/utils";

$userMarkerHeight: 3.75em;
$userMarkerWidth: 4em;
$groupMarkerHeight: 5.5em;
$groupMarkerWidth: 6.25em;
$itemMarkerHeight: 5.375em;
$itemMarkerWidth: 6.875em;
$arrowHeight: 0.62em;

.objectMarker{
  // Override .leaflet-container font-size:12px
  display: block;
  font-size: 1rem;
  color: $dark-grey;
  @include bg-hover(white, 10%);
  @include radius;
  @include shy-border;
  position: relative;
  .username, .name{
    white-space: nowrap;
    @include position(absolute, null, 0, 0, 0, 1);
    @include sans-serif;
    color: $dark-grey;
    font-weight: bold;
    overflow: hidden;
    background-color: white;
    line-height: 1em;
    padding: 0.2em;
  }
  .picture{
    background-size: cover;
    background-position: center center;
    @include position(absolute, 0, 0, 0, 0, 0);
  }
}

// Drawing the marker triangle
// Adapted from https://cssarrowplease.com
.objectMarker{
  position: relative;
  background-color: white;
  box-shadow: 10px 10px 10px rgba(black, 0.5);
}

.objectMarker:after{
  inset-block-start: 100%;
  inset-inline-start: 50%;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border: solid transparent;
  border-top-color: white;
  // 11px makes it 1px too wide on the right
  // but it prevent the little bug occuring with 10px
  border-width: 0.68em;
  margin-inline-start: -0.62em;
}

.userMarker, .groupMarker, .mainUserMarker{
  min-height: $userMarkerHeight;
  min-width:  $userMarkerWidth;
}

.userMarker, .mainUserMarker{
  // (1)
  margin-block-start: -$userMarkerHeight - $arrowHeight ;
  margin-inline-start: -$userMarkerWidth*0.5 + 0.25em;
  position: relative;
  #showPositionPicker, .items-count{
    position: absolute;
    inset-block-start: 0;
    inset-inline-end: 0;
  }
  #showPositionPicker{
    font-size: 1.4rem;
    color: white;
    padding: 0.2em 0;
    @include bg-hover($light-blue);
    @include radius;
  }
}
.mainUserMarker{
  opacity: 0.7;
}
.groupMarker{
  // (1)
  margin-block-start: -$groupMarkerHeight - $arrowHeight + 0.25em;
  margin-inline-start: -$groupMarkerWidth*0.5 + 0.25em;
  // Forcing the height to prevent .fa-group to increase the height
  // which, given its absolute position, might be a conflict with leaflet rules
  height: $groupMarkerHeight;
  min-width: $groupMarkerWidth;
}

.itemMarker{
  // (1)
  margin-block-start: -$itemMarkerHeight - $arrowHeight + 0.25em;
  margin-inline-start: -$itemMarkerWidth*0.5 + 0.25em;
  min-height: 5.5em;
  min-width:  7em;
  .showItem{
    position: relatives;
    @include display-flex(row);
    .icon-wrapper{
      position: absolute;
      inset-block-end: -1px;
      inset-inline-end: -2px;
      z-index: 2;
      .fa{
        border-start-start-radius: $global-radius;
        border-end-end-radius: $global-radius;
        padding: 0.2em 0.3em;
        font-size: 1.3em;
      }
    }
    // Using a class+"!important" to override leaflet.css own "!important"
    .marker-img{
      max-height: 64px !important;
      max-width: 64px !important;
      overflow: hidden;
    }
  }
  .giving{ @include box-color($giving-color); }
  .lending{ @include box-color($lending-color); }
  .selling{ @include box-color($selling-color); }
  .inventorying{ @include box-color($inventorying-color); }
}

// (1) - By default, the icon has it's coordinates for top-left point
//       margins hereafter compensate to make the icon point at its true position
//       Additional pixels are the result of empirical tests
